var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { alloy, info } from '../colors';
const standardDimensions = {
    large: '72px',
    medium: '38px',
    small: '16px',
};
const pageCenter = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
};
export default class Spinner extends PureComponent {
    constructor() {
        super(...arguments);
        this.getCurrentOffset = () => {
            const { duration } = this.props;
            return (this.el.getCurrentTime() % duration) / duration;
        };
        this.renderSpinner = () => {
            let { offset } = this.props;
            const _a = this.props, { duration, fullPage, handleOffset, size } = _a, rest = __rest(_a, ["duration", "fullPage", "handleOffset", "size"]);
            offset %= 1;
            const begin = (1 - offset) * duration - duration;
            return (React.createElement("div", Object.assign({ className: `spinner ${this.props.className}`, style: fullPage ? pageCenter : {} }, rest),
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: standardDimensions[size] || standardDimensions.large, height: standardDimensions[size] || standardDimensions.large, viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid", className: "uil-ring-alt", ref: el => (this.el = el) },
                    React.createElement("rect", { x: "0", y: "0", width: "100", height: "100", fill: "none", className: "bk" }),
                    React.createElement("circle", { cx: "50", cy: "50", r: "40", stroke: alloy, fill: "none", strokeWidth: "10", strokeLinecap: "butt" }),
                    React.createElement("circle", { cx: "50", cy: "50", r: "40", stroke: info.darkest, fill: "none", strokeWidth: "10", strokeLinecap: "butt" },
                        React.createElement("animate", { attributeName: "stroke-dashoffset", dur: duration, repeatCount: "indefinite", from: "0", to: "-502", begin: begin }),
                        React.createElement("animate", { attributeName: "stroke-dasharray", dur: duration, repeatCount: "indefinite", values: "75.3 175.7;1 250;75.3 175.7", begin: begin })))));
        };
    }
    componentWillUnmount() {
        this.props.handleOffset && this.props.handleOffset(this.getCurrentOffset());
    }
    render() {
        return this.props.fullPage
            ? ReactDOM.createPortal(this.renderSpinner(), document.body) : this.renderSpinner();
    }
}
Spinner.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['large', 'medium', 'small']),
    duration: PropTypes.number,
    offset: PropTypes.number,
    handleOffset: PropTypes.func,
    fullPage: PropTypes.bool,
};
Spinner.defaultProps = {
    size: 'large',
    className: '',
    duration: 2,
    offset: 0,
    fullPage: false,
};
